/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionPackagingUnitHierarchyDto } from '../../models/collection-packaging-unit-hierarchy-dto';

export interface GetCollectionPackagingUnitHierarchies$Params {
  packagingUnitId: string;
}

export function getCollectionPackagingUnitHierarchies(http: HttpClient, rootUrl: string, params: GetCollectionPackagingUnitHierarchies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Array<CollectionPackagingUnitHierarchyDto>>>> {
  const rb = new RequestBuilder(rootUrl, getCollectionPackagingUnitHierarchies.PATH, 'get');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Array<CollectionPackagingUnitHierarchyDto>>>;
    })
  );
}

getCollectionPackagingUnitHierarchies.PATH = '/products/{packagingUnitId}/collections';
